/* eslint-disable no-console */
function printJoinUsMessage(url) {
  if (typeof window === 'undefined') return;

  console.log(`%c
.                                            .
.        ;oollll;.                           .
.      .:0k;,'';oxc.    .....     .....      .
.     ,ddkXOlldo, ,ko   .oOodk:   ,kxokx.    .
.    .kd.;Oc  .xx. dk.  .kd .ko   cO, lO'    .
.    'Ol ,Oc   lk. ok.  .kd .ko   cO, lO'    .
.    'Ol ,Oc   lk. dk.  .kd .ko   cO, lO'    .
.    'Ol ,Oc   ok. dk.  .ko .ko   cO, lO'    .
.    'Ol ,Oc   lk. dk.  .ko .kl   cO, lO'    .
.    'Oo.;Oc   lk'.dk.  .kd..xk'  lO:.xx.    .
.    .oxodd'   ;xdoxl.   ck:..loloOXkol.     .
.    ...       ..       ;ddc;,,:kO,          .
.                        ':llllc'            .
.                                            .`,
  'color: #FFFFFF; background: #8A05BE;');
  console.log(`%c Join us :) ${url}`, 'color: #FFFFFF; background: #8A05BE;');
}

export default printJoinUsMessage;
